// extracted by mini-css-extract-plugin
export default {"errorContainer":"_249ILSZhN1zNDPTTQAj1q4","errorIcon":"_2ihX7U_OdV7UMAx_C7vo1K"};